import {DisplayValue} from '@shipwell/shipwell-ui';

export const MovementDetailsItem = ({label, value}: {label: string; value?: string | null}) => (
  <DisplayValue label={label}>
    <div className="break-words">{value || '--'}</div>
  </DisplayValue>
);
